import React, { useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import style from "./Styles.module.css";
import SidebarContext from "../contexts/sidebarContext";
import Map from "app/components/_molecules/Map";

const MainLayout = () => {
  const sidebarCtx = useContext(SidebarContext);

  useEffect(() => {
    if (document.body.classList.contains("sidebar__open")) document.body.classList.remove("sidebar__open");
  }, []);

  return (
    <div className="flex">
      <div className={style.main}>
        <div className={`${style.mainContent} ${!sidebarCtx.isOpen ? style.closeSidebar : ""} main_wrapper`}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
